import * as XLSX from "xlsx";

export const exportClearskiesToExcel = (data, fileName) => {
  const flattenedData = data.map((item) => ({
    Received: item?.timestamp || "",
    Journal: item.journal_name || "",
    "Manuscript ID": item.manuscript_id || "",
    "Manuscript title": item.title || "",
    Alarm: item?.screening_outcomes?.[0].items[0]?.value ?? "",
  }));

  const worksheet = XLSX.utils.json_to_sheet(flattenedData);

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Clearskies");

  XLSX.writeFile(workbook, `${fileName}.xlsx`);
};
